<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'Mannings',
  props: {
    mannings : {
      default : null,
      type : Object, //array
    }
  }
};
</script>

<style scoped>

</style>
